import React from "react";

export const Variants = ({ variants, page, assignPoint }) => {
  return (
    <div className="test-card__details__side">
      <fieldset className="test-card__fieldset">
        {variants.map((x, idx) => (
          <div className="test-card__details__radio" key={x.title}>
            <input
              className="test-card__input"
              key={x.value}
              type="radio"
              required
              name={`${page}variant`}
              id={`${page}variant${idx}`}
              onClick={() => {
                assignPoint(page, x.value);
              }}
            />
            <label
              className="test-card__label"
              htmlFor={`${page}variant${idx}`}
            >
              {x.title}
            </label>
          </div>
        ))}
      </fieldset>
    </div>
  );
};
